import * as B from '@blueprintjs/core';
import {DateRange, DateRangeInput3} from '@blueprintjs/datetime2';
import React from 'react';

import * as C from 'app/utils/constants';

import cs from '../styles.module.scss';
import {AlertFormAction, AlertFormState} from '../useAlertForm';

export const TimeAlertStep: React.FC<{
  disableInputs: boolean;
  formState: AlertFormState;
  dispatch: React.Dispatch<AlertFormAction>;
}> = React.memo(({formState, dispatch, disableInputs}) => {
  // A composite windows scenes the same way a threshold does.
  const scenesProps =
    formState.alertType === C.CUSTOM_ALERT_TYPE_THRESHOLD ||
    formState.alertType === C.CUSTOM_ALERT_TYPE_COMPOSITE
      ? formState.properties
      : undefined;

  return (
    <div className={cs.dialogPanel}>
      {scenesProps && (
        <B.FormGroup label="Number of consecutive scenes">
          <B.NumericInput
            fill={true}
            className={cs.compressedNumericInput}
            value={scenesProps.numConsecutiveScenes}
            onValueChange={(value) => dispatch({type: 'SET_NUM_SCENES', value})}
            min={1}
            disabled={disableInputs}
          />
        </B.FormGroup>
      )}

      <B.FormGroup
        label="Set monitoring season"
        labelInfo="(optional)"
        subLabel={'Only check during specific time periods each year.'}
      >
        <div className={cs.datepickerNoYearSelect}>
          <DateRangeInput3
            shortcuts={false}
            value={formState.properties.dateRange as DateRange | undefined}
            onChange={(dateRange) =>
              dispatch({
                type: 'SET_DATE_RANGE',
                dateRange: dateRange,
              })
            }
            minDate={new Date(new Date().getFullYear(), 0, 1)}
            maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
            formatDate={(date) =>
              date.toLocaleDateString('en-US', {
                year: undefined,
                month: 'long',
                day: 'numeric',
              })
            }
            popoverProps={{
              usePortal: false,
              minimal: true,
            }}
            disabled={disableInputs}
          />
        </div>
      </B.FormGroup>
    </div>
  );
});
